function getTotalAmountOfSlots(slots = {}) {
  return Object.values(slots)
    .reduce((acc, slot) => acc + slot.length, 0)
    .toString();
}

function getDaysBySlots(slots = {}) {
  // Maximum days allowed on the 'days' prop, if more than 14 put the rest on 'extraDays'
  const MAX_DAYS = 14;
  const slotsArray = Object.keys(slots);

  const limitedDays = slotsArray
    .slice(0, MAX_DAYS)
    .map(day => day.replace(/-/g, '').substring(2))
    .join();

  const extraDays = slotsArray
    .slice(MAX_DAYS)
    .map(day => day.replace(/-/g, '').substring(2))
    .join();

  return [`[${limitedDays}]`, `[${extraDays}]`];
}

function getNewSlotsFormat(slots = {}) {
  const slotsArray = Object.values(slots);

  // We need 14 props, 'timeSlots1' till 'timeSlots14'
  return [...Array(14)].reduce((obj, _, idx) => {
    const key = `timeSlots${idx + 1}`;

    let value;
    if (slotsArray[idx]) {
      value = slotsArray[idx]?.map(slot => slot.split(':').join('').substring(0, 3));
      value = `[${value.join()}]`;
    }

    obj[key] = value || 'undefined';

    return obj;
  }, {});
}

export default function (slots) {
  const totalAmountOfSlots = getTotalAmountOfSlots(slots);
  const [days, extraDays] = getDaysBySlots(slots);
  const newSlots = getNewSlotsFormat(slots);

  return { totalAmountOfSlots, days, extraDays, newSlots };
}
